import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { DistributorProduct } from '../../models/distributor-product';
import { DistributorProductsService } from '../services/distributor-products.service';

@Injectable()
export class DistributorProductResolver implements Resolve<DistributorProduct>
{
	private distributorProductsService: DistributorProductsService;

	constructor(distributorProductsService: DistributorProductsService)
	{
		this.distributorProductsService = distributorProductsService;
	}

	resolve(route: ActivatedRouteSnapshot): Promise<DistributorProduct>
	{
		return this.distributorProductsService.getDistributorProduct(route.params['productId']);
	}
}



// WEBPACK FOOTER //
// ./src/app/distributors/resolvers/distributor-product.resolver.ts